import { useDialog } from '@repo/ui';
import { useRouter } from 'next/router';

import { getIndisSearchRefundData } from '@/components/tax-refund/common/data/indis-search-refund-data';
import HometaxEqualTinError from '@/components/tax-refund/common/view/ErrorView/HometaxEqualTinError';
import { COMMON_PATHS, DECISION_PATHS } from '@/lib/constants/paths';
import useDetectOs from '@/lib/hooks/use-detect-os';
import { ellipsisName } from '@/lib/utils/ellipsisName';
import { checkHometaxAvailableTime } from '@/lib/utils/hometax-time';

const DecisionErrorEqualTinContent = () => {
  const { bizName } = getIndisSearchRefundData() ?? {};
  const router = useRouter();
  const { showDialog } = useDialog();
  const detectOS = useDetectOs();

  const checkHometaxHour = () => {
    /* 오전 6시 ~ 밤 0시 아닌 경우 홈택스 조회 불가 */
    if (!checkHometaxAvailableTime()) {
      showDialog({
        title: '아침 6시 이후에 조회해주세요',
        description: '매일 밤 0시부터 아침 6시까지 홈택스 점검으로 환급액 조회가 어려워요.',
        buttons: {
          primary: {
            onClick: () => {
              router.push({
                pathname: COMMON_PATHS.환급신청결과,
                query: { type: 'indis' }
              });
            }
          }
        }
      });
      return false;
    }
    return true;
  };

  const retryAction = () => {
    if (!checkHometaxHour()) return;

    if (detectOS === 'windows') {
      router.push({
        pathname: DECISION_PATHS.결정확인방법선택,
        query: router.query
      });
    } else {
      router.push({
        pathname: COMMON_PATHS.간편인증_정보입력,
        query: Object.assign({}, router.query, { from: 'decision' })
      });
    }
  };

  const taxpayerName = ellipsisName(bizName, '고객');

  return <HometaxEqualTinError taxpayerName={taxpayerName} onPrimaryButtonClick={retryAction} />;
};

export default DecisionErrorEqualTinContent;
